import { render, staticRenderFns } from "./ruta-todos.vue?vue&type=template&id=897690cc&"
import script from "./ruta-todos.vue?vue&type=script&lang=js&"
export * from "./ruta-todos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports